import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'

import { ButtonGroup, Button } from '@mui/material'

const Menu = ({user}) => {

  const navigate = useNavigate()
  const page = location.pathname.split("/").pop()

  const buttons = useMemo(() => {
    let t = []
    
    
    if (user?.permissions.client_admin) {
      t.push(<Button key="details" sx={{color:page === "details" ? "link" : "text.secondary"}} onClick={() => navigate("../details")}>Company Details</Button>)
      t.push(<Button key="contact" sx={{color:page === "contact" ? "link" : "text.secondary"}} onClick={() => navigate("../contact")}>Contacts</Button>)
      t.push(<Button key="users" sx={{color:page === "users" ? "link" : "text.secondary"}} onClick={() => navigate("../users")}>Users</Button>)
      t.push(<Button key="api-keys" sx={{color:page === "api-keys" ? "link" : "text.secondary"}} onClick={() => navigate("../api-keys")}>API Keys</Button>)
    }
    t.push(<Button key="password" sx={{color:page === "password" ? "link" : "text.secondary"}} onClick={() => navigate("../password")}>Password</Button>)
    
    if (user?.permissions.client_admin) {
      t.push(<Button key="delete" sx={{color:"red"}} onClick={() => navigate("../delete")}>Delete Account</Button>)
    }
    return t
  },[user,page])

  return (
    <div className='flex flex-col'>
      <div className='flex flex-row justify-end w-full'>
        <ButtonGroup variant="text" aria-label="Actions">
          {buttons}
        </ButtonGroup>
      </div>
    </div>
  )
}

export default Menu